import { Pipe, PipeTransform } from '@angular/core';
import { isInternationalCountry } from 'core/geography';
import { AppPersistantStateService } from 'core/state/app-state.service';
import { CampaignWithoutTags, CampaignWithoutTagsFragment } from 'generated/graphql';
import parsePhoneNumber, { getCountryCallingCode } from 'libphonenumber-js-custom'
import { isNil } from 'lodash-es';

/*
 * Returns formatted phone number when given 10 or 11 digits.
 *  *
 * Usage:
 *   phoneNumber = 5551234567
 * Example:
 *   {{ phoneNumber | phone }}
 *   formats to: (555) 123-4567
*/
@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform {
  constructor(private appStateService: AppPersistantStateService) {}
  transform(value: string) {
    try {
      const campaignCountry = this.campaignCountry();
      const pn = parsePhoneNumber(
        value || '', !value?.includes('+') ? campaignCountry : null
      );

      if (!pn) {
        return '';
      }

      if (isInternationalCountry(campaignCountry)) {
        // If the campaign is UK/Europe-based
        if (pn?.countryCallingCode === getCountryCallingCode(campaignCountry)) {
          // Format numbers from the campaign's country as national
          return pn.formatNational();
        } else {
          // Format numbers from other countries as international
          return pn.formatInternational();
        }
      } else if (pn?.countryCallingCode === '1') {
        // Format US/Canada numbers as national
        return pn.formatNational();
      } else {
        // Default to international format for other cases
        return pn.formatInternational();
      }
    } catch {
      return '';
    }
  }

  private campaignCountry() {
    const defaultCountry =  this.appStateService.getValue<CampaignWithoutTagsFragment>(this.appStateService.STORE_NAMES.CurrentCampaign)?.defaultCountry

    return defaultCountry || 'US';
  }
}
